import partner from "~/utils/partner";

const checkApiByParnerId = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("hotfix")) {
    return "https://api-hotfix.medpro.com.vn";
  }

  switch (partner) {
    // case "umc":
    //   return "https://medpro-api-v2-testing.medpro.com.vn";

    default:
      // return "https://api-v2.medpro.com.vn";
      // return "https://api-111.medpro.com.vn";
      return "https://medpro-api-v3-testing.medpro.com.vn";
  }
};

const checkApiLogin = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("hotfix")) {
    return `https://id-v121.medpro.com.vn/check-phone`;
  }

  switch (partner) {
    default:
      // return "http://internal-medpro.ddns.net:3007/check-phone";
      // return `https://id-v121.medpro.com.vn/check-phone`;
      return `https://id-testing.medpro.com.vn/check-phone`;
  }
};

// Api backend
export const RESTFULL_API_URL = checkApiByParnerId();

// Api hình ảnh và nội dung
export const STATIC_CONTENT_API_URL = "https://bo-api-testing.medpro.com.vn";

// export const STATIC_CONTENT_API_URL = "https://resource-testing.medpro.com.vn";
// export const STATIC_CONTENT_API_URL = `https://resource.medpro.com.vn`;

// Link login tới medproId

export const MEDPRO_LOGIN = checkApiLogin();

// Thời gian sống 12*60*60; // 12 tiếng
export const COOKIE_EXPIRES = 43200;

// wechat
export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";

// link thanh toán paymenthub
export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const LINK_API_COVID19 = "https://khaibaoyte-testing.medpro.com.vn";

export const BO_API = "https://bo-api-testing.medpro.com.vn";
